// styled components
import {Menu, UserWrapper} from '../style';
import styled from 'styled-components/macro';

// components
import ProfilePhotoImage from '@components/ProfilePhotoImage';

// utils
import {ClickAwayListener} from '@mui/base/ClickAwayListener';
import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {authService} from '@services/auth.service.js';
import {useProfilePhoto} from '@hooks/useProfilePhoto';
import {getRoleIdFromUser, getRoleNameFromUser} from '@utils/roleAccess';
import {colors} from '@styles/vars';


const InitialAvatar = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 700;
    color: #fff;
    background: ${colors.blue};
    text-transform: uppercase;
`;

const HeaderPhoto = styled(ProfilePhotoImage)`
    width: 40px;
    height: 40px;
    border-radius: 8px;
    object-fit: cover;
`;

const roleDisplayLabel = user => {
    const folded = getRoleNameFromUser(user);

    if (folded.includes('super')) return 'SuperAdmin';
    if (folded.includes('admin')) return 'Admin';
    if (folded.includes('doctor') || folded.includes('medico')) return 'Medico';

    const roleId = getRoleIdFromUser(user);
    const byId = {1: 'SuperAdmin', 2: 'Admin', 3: 'Medico', 4: 'Usuario'};
    if (byId[roleId]) return byId[roleId];

    return 'Usuario del sistema';
};

const CurrentUser = () => {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [user, setUser] = useState(() => authService.getUser());
    const {path: photoPath, blobSrc: photoBlobUrl, failed: photoFailed, setFailed: setPhotoFailed, hasPhoto} =
        useProfilePhoto(user?.foto_perfil_url);
    const handleClickAway = () => setOpen(false);
    const handleClick = () => setOpen(!open);

    useEffect(() => {
        const onAuthUser = e => {
            setUser(e.detail?.user || authService.getUser());
        };

        window.addEventListener('auth-user-updated', onAuthUser);
        return () => window.removeEventListener('auth-user-updated', onAuthUser);
    }, []);

    const handleLogout = () => {
        authService.logout();
        navigate('/login', {replace: true});
    };

    const fullName = [user?.nombre, user?.apellidos].filter(Boolean).join(' ').trim() || user?.name || user?.email || 'Usuario';
    const roleLabel = roleDisplayLabel(user);
    const initials = fullName
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map(part => part[0])
        .join('') || 'U';

    return (
        <ClickAwayListener onClickAway={handleClickAway}>
            <UserWrapper>
                {hasPhoto && !photoFailed ? (
                    <HeaderPhoto
                        path={photoPath}
                        blobSrc={photoBlobUrl}
                        alt="avatar"
                        onAllFailed={() => setPhotoFailed(true)}
                    />
                ) : (
                    <InitialAvatar className="avatar">{initials}</InitialAvatar>
                )}
                <div className="info">
                    <span className="h3">{fullName}</span>
                    <span className="position">{roleLabel}</span>
                    <Menu className={open ? 'visible' : ''}>
                        <button onClick={handleLogout}>
                            <i className="icon icon-logout" /> Cerrar sesion
                        </button>
                    </Menu>
                </div>
                <button className="trigger" onClick={handleClick} aria-label="Show menu">
                    <i className="icon icon-chevron-down" />
                </button>
            </UserWrapper>
        </ClickAwayListener>
    )
}

export default CurrentUser;